import React, { useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import { GlobalGet } from "../../../../../helpers/fetcher";
import colors from "../../../../../constant/hexColors.json";
import { Link } from "react-router-dom";
import Environtment from "../../../../../constant/environtment.json";

ChartJS.register(ArcElement, Tooltip, Legend);

const Screen = ({ businessData }) => {
  const { REACT_APP_LOCALHOST, REACT_APP_API_TEMPORARY_SERVER } = Environtment;
  const [businessUnits, setBusinessUnit] = useState([]);
  const [valuation, setValuation] = useState([]);
  const role = localStorage.getItem("role");
  const data = {
    labels: businessUnits,
    datasets: [
      {
        data: valuation,
        backgroundColor: colors[0].hex,
        borderWidth: 1,
      },
    ],
  };
  const options = {
    plugins: {
      legend: {
        position: "bottom",
        display: "grid",
      },
    },
  };
  const [loading, setLoading] = useState(false);
  const fetchBusinessUnit = async () => {
    setLoading(true);
    try {
      const resp = await GlobalGet({
        url: `${REACT_APP_API_TEMPORARY_SERVER}business`, // temporary json server
      });
      const dataBusiness = resp.map((el) => el.business_unit.name);
      const dataValuation = resp.map((el) => el.value);
      setBusinessUnit(dataBusiness);
      setValuation(dataValuation);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(true);
    }
  };
  React.useEffect(() => {
    fetchBusinessUnit();
  }, []);
  return (
    <div className="h-screen m-10">
      <div className="flex">
        <div className="font2 w-[49%]">
          <h1 className="text-[24px]">Business Unit Chart</h1>
        </div>
        {role === "business" && (
          <div className="w-[50%] flex justify-end">
            <div className="flex items-center">
              <p className="mr-2">Add: </p>
              <Link
                to="/business/dashboard/total-business/list"
                className="border-2 rounded-lg p-2 font2 shadow-[0_15px_12px_-12px_rgba(0,0,0,0.3)]"
              >
                Business +
              </Link>
            </div>
          </div>
        )}
      </div>
      <div className="w-full flex justify-center">
        <div className="w-1/2 mt-10">
          <Pie data={data} options={options} />
        </div>
      </div>
    </div>
  );
};

export default Screen;
